import React, { useState, useEffect } from 'react';
import { getHealthStatus } from '../api/superAdminApi';
import type { HealthStatus } from '../types';
import { VERSION_INFO } from '../../../contexts/AuthContext';

const AdminFooter: React.FC = () => {
  const [health, setHealth] = useState<HealthStatus | null>(null);

  useEffect(() => {
    let cancelled = false;
    const check = () => {
      getHealthStatus()
        .then((data) => { if (!cancelled) setHealth(data); })
        .catch(() => { if (!cancelled) setHealth(null); });
    };
    check();
    const interval = setInterval(check, 60_000); // Check every 60s
    return () => { cancelled = true; clearInterval(interval); };
  }, []);

  const currentYear = new Date().getFullYear();
  const version = VERSION_INFO.backend_version || '1.0.0';
  const commit = VERSION_INFO.git_commit && VERSION_INFO.git_commit !== 'unknown'
    ? VERSION_INFO.git_commit
    : null;

  return (
    <footer className="border-t border-slate-200 bg-white px-4 py-3 lg:px-6">
      <div className="flex flex-wrap items-center justify-between gap-2 text-xs text-slate-500">
        <div className="flex items-center gap-3">
          <span>&copy; {currentYear} eSanza Ltd</span>
          <span className="hidden sm:inline">·</span>
          <span className="hidden sm:inline">v{version}{commit ? ` · ${commit}` : ''}</span>
        </div>

        <div className="flex items-center gap-3">
          {/* Health indicator */}
          <span className="flex items-center gap-1.5">
            <span
              className={`inline-block w-2 h-2 rounded-full ${
                health?.status === 'healthy' ? 'bg-emerald-500' : 'bg-red-500'
              }`}
              title={health?.status === 'healthy' ? 'API healthy' : 'API unreachable'}
            />
            <span className="hidden sm:inline">API {health?.status === 'healthy' ? 'healthy' : 'unreachable'}</span>
          </span>

          <a href="/dashboard/audit-logs" className="hover:text-slate-700 transition-colors">Audit</a>
        </div>
      </div>
    </footer>
  );
};

export default AdminFooter;
